import { Anchor, Checkbox, Flex, Grid, Group } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import InputLabel from 'components/InputLabel';
import PrivacyPolicyModal from 'components/PrivacyPolicyModal';
import { IPageData } from '.';

const PrivacyPolicy = ({ form, isMobile, t }: IPageData) => {
  const [modalOpened, { open, close }] = useDisclosure(false);

  return (
    <>
      <PrivacyPolicyModal
        t={t}
        form={form}
        isMobile={isMobile}
        opened={modalOpened}
        onClose={close}
      />
      <Grid columns={isMobile ? 1 : 12} mt={20}>
        <Grid.Col span={isMobile ? 1 : 12}>
          <Flex gap={'md'}>
            <Checkbox
              color={'#62AF45'}
              checked={form.values.privacyPolicy}
              key={form.key('privacyPolicy')}
              {...form.getInputProps('privacyPolicy')}
              onChange={(event) => form.setFieldValue('privacyPolicy', event.currentTarget.checked)}
              label={
                <Group gap={4}>
                  <InputLabel label={t('privacy.policy.accept.0')}/>
                  <Anchor onClick={open} underline='always'>
                    <InputLabel label={t('privacy.policy.accept.1')} />
                  </Anchor>
                  <InputLabel label={t('privacy.policy.accept.2')} />
                </Group>
              }
            />
          </Flex>
        </Grid.Col>
      </Grid>
    </>
  )
}

export default PrivacyPolicy;